// For New Product Check

import { AppSettings, Product } from "@core/types";

export const checkProductNew = (
  productDateCreated: Product["dateCreated"],
  configNewProductDuration: AppSettings["newProductDuration"]
) => {
  if (!productDateCreated || !configNewProductDuration) return null;

  const productDate = new Date(productDateCreated);
  const date = productDate.getTime() + +configNewProductDuration * 86400000;

  const todayDate = new Date().getTime();
  return date > todayDate;
};
